<template>
  <article
    :id="'rexer_event-' + event.id"
    :class="renderClass(event)"
    class="rexer_event"
  >
    <section class="rexer_event__header">
      <div class="rexer_event__time">
        <span class="rexer_event__time-date">
          {{ event.date_time | moment("DD.MM.YY, HH.mm") }} UHR
        </span>
      </div>
    </section>
    <section class="rexer_event__body">
      <h3 class="rexer_event__body-title">
        {{ event.title.rendered }}
      </h3>
      <div
        v-if="event.excerpt.rendered"
        class="rexer_event__body-desc"
        v-html="event.excerpt.rendered"
      />
      <!--  -->
      <div class="rexer_event__contact">
        <h6 class="has-text-white">Informationen &amp; Reservationen:</h6>
        <EventContact
          v-if="event.email !== ''"
          :text="event.email"
          type="email"
        />
        <EventContact
          v-if="event.website !== ''"
          :text="event.website"
          type="www"
        />
      </div>
      <p class="rexer_event__body-location">
        {{ event.location }}
      </p>
      <div class="rexer_event__brand">
        <a
          :href="event.brand_url!=='' ? event.brand_url : '#'"
          :title="event.title.rendered"
          target="_blank"
        >
          <img
            :src="event.branding.guid"
            :alt="event.branding.post_title"
          >
        </a>
      </div>
    </section>
    <section class="rexer_event__footer" />
  </article>
</template>

<script>
import { svg } from '../helpers/config'
import EventContact from './EventContact'
export default {
  name: 'EventCard',
  components: {
    EventContact
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    destination: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      arrow: svg.ARROW_RIGHT,
      globe: svg.GLOBE,
      email: svg.EMAIL
    }
  },
  methods: {
    showTime (val) {
      return 'UHR'
    },
    renderClass (val) {
      let res = ''
      switch (val.eventtype) {
        case '1':
          res = res + 'is-blue '
          break
        case '2':
          res = res + 'is-purple '
          break
        case '3':
          res = res + 'is-green '
          break
      }
      if (val.acf.location_event) {
        res = res + val.acf.location_event.value + ''
      }
      return res
    }
  }
}
</script>

<style lang="scss">
$text-color: #fff;
$card-bg-color: #000;
$purple: #b004ff;
$blue: #0248ff;
$green: #00ff00;

.has-text-white {
  color: #fff
}
.rexer_event{
  $self: &;
  margin-bottom: 1rem;
  line-height: 1.2;

  &__body, &__footer, &__header{
    padding: 1.25rem;
  }
  &__header {
    margin-bottom: 6px;
  }
  &__body, &__footer{
    background: $card-bg-color;
    color: $text-color;
    font-weight: 300;
  }
  &__button {
    background: #fff;
    box-sizing: border-box;
    cursor: pointer;
    display: block;
    padding: 0.5rem 1.25rem;
    width: 50%;
    font-size: 1rem;
    position: relative;
    line-height: 32px;
    height: 50px;
    transition: all 550ms ease;
    &:hover, &:active, &:focus {
      color: #000;
      width: 100%;
      svg {
        fill: #fff;
      }
    }
  }
  &__body-title {
    color: $text-color;
    text-transform: uppercase;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  &__time-date {
    font-size: 2rem;
  }
  &__body-location {
    color: $text-color;
    font-size: 1rem;
  }
  &__body-desc {
    padding: 1rem 0;
    min-height: 120px;
    p {
      line-height: 1.5;
      font-size: 1rem;
    }
  }
  .arrow-right {
    display: block;
    position: absolute;
    top: 45%;
    margin-top: -10px;
    right: 1rem;
    svg{
      width: 18px;
      fill: #000;
    }
  }
  &__brand {
    margin: 2rem 0;
    img{
      width: 100%;
      max-width: 180px;
    }
  }
  &__contact {
    margin-bottom: 1em;
  }
  // event type:
  // 1: comedy
  // 2: dinner
  // 3: rexer
  &.is-blue{
    #{ $self }__header {
      background: $blue;
      color: $text-color;
    }
    #{ $self }__button {
      &:hover, &:active, &:focus {
        background: $blue;
        color: $text-color;
      }
    }
  }
  &.is-green{
    #{ $self }__header {
      background: $green;
      color: $text-color;
    }
    #{ $self }__button {
      &:hover, &:active, &:focus {
        background: $green;
        color: $text-color;
      }
    }
  }
  &.is-purple{
    #{ $self }__header {
      background: $purple;
      color: $text-color;
    }
    #{ $self }__button {
      &:hover, &:active, &:focus {
        background: $purple;
        color: $text-color;
      }
    }
  }

}
</style>
